import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import throttle from 'lodash/throttle';
import urlJoin from 'url-join';
import serviceSDK from '@nerdwallet/nw-api-sdk/service-sdk';
var MAX_RETRY = 5;

var Logger = /*#__PURE__*/function () {
  function Logger() {
    var _this = this;

    _classCallCheck(this, Logger);

    var logFns = ['debug', 'info', 'warn', 'error'];
    this.messages = [];
    logFns.forEach(function (logFn) {
      _this[logFn] = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this.log.apply(_this, [logFn.toUpperCase()].concat(args));
      };
    });
    this.retryCount = 0;
    this.sendLogs = throttle(this.sendLogs, 200);
    this.service = serviceSDK({
      clientID: process.env.CLIENT_ID
    });
  }

  _createClass(Logger, [{
    key: "sendLogs",
    value: function sendLogs() {
      var _this2 = this;

      // TODO: Handle Server side logging
      // Instead of sending the logs through an api post it should
      // just call directly to the logging lib,
      // no need to the extra api call
      var messages = this.messages;
      this.messages = [];
      var url = urlJoin(process.env.BASE_URI, '/api/log');
      this.service.post(url, messages, function (err) {
        if (err && _this2.retryCount < MAX_RETRY) {
          // eslint-disable-next-line no-plusplus -- directive added automatically by Shepherd migration
          _this2.retryCount++;
          _this2.messages = messages.concat(_this2.messages);

          _this2.sendLogs();

          return;
        }

        _this2.retryCount = 0;
      });
    }
  }, {
    key: "log",
    value: function log(level, message, meta) {
      this.messages.push({
        level: level,
        message: message,
        meta: meta
      });
      this.sendLogs();
    }
  }]);

  return Logger;
}();

var logger = new Logger();
export default logger;